import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { TextField } from '@anm/components/form/fields';
import { FormValues } from '@anm/components/templates/TemplateMetaEditModal';
import noop from '@anm/helpers/noop';
import { Config as FinalFormConfig } from 'final-form';
import { useCallback, FC, SyntheticEvent } from 'react';
import { Form, FormRenderProps } from 'react-final-form';

import FormWrapper, { ButtonsContainer, DescriptionField, TagsField } from './Wrapper';

export type TemplateMetaFormProps = {
  isPendingSubmit: boolean;
  onSubmit(values: FormValues): void;
  onCancel?(): void;
};

const renderForm = ({ isPendingSubmit, onSubmit, onCancel = noop }: TemplateMetaFormProps) => ({
  values
}: FormRenderProps) => {
  const handleSubmit = useCallback(
    (e: SyntheticEvent) => {
      e.preventDefault();
      onSubmit(values as FormValues);
    },
    [values]
  );

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <TextField name="displayName" label="Name" inputVariant="simple-small" labelVariant="static-above" />
      <TextField name="slug" label="Slug" inputVariant="simple-small" labelVariant="static-above" />
      <DescriptionField resize={false} name="description" label="Description" labelVariant="static-above" />
      <TagsField resize={false} name="tags" label="Tags (comma separated)" labelVariant="static-above" />
      <ButtonsContainer>
        <ButtonLoader size="large" variant="blue-heavy-border" onClick={onCancel}>
          Cancel
        </ButtonLoader>
        <ButtonLoader size="large" color="white" variant="light-blue" buttonType="submit" isPending={isPendingSubmit}>
          Update
        </ButtonLoader>
      </ButtonsContainer>
    </FormWrapper>
  );
};

const TemplateMetaForm: FC<FinalFormConfig & TemplateMetaFormProps> = props => (
  <Form render={renderForm(props)} {...props} />
);

export default TemplateMetaForm;
